import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    arrow: {
        fill: '#fff', width: 10, height: 10,
    },
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    }
}));

const getRows = (rezymeArr) => {
    return rezymeArr.map((item) => {
        return {
            ip: item.ip, 
            browser: item.client_information_user_agent,
        }
    })
}

const columns = [
    { id: 'ip', label: 'IP адесс'},
    { id: 'browser', label: 'Браузер'},
];

export {
    useStyles,
    columns,
    getRows
}